<div class="modal-content">
    <div class="modal-header">
        <h2>{{ modal?.title }}</h2>
        <lsq-button
            *ngIf="!isSubmitting"
            appearance="transparent"
            class="close"
            ariaLabel="Close"
            (buttonClick)="modalService.closeModal()"
        >
            <lsq-icon aria-hidden="true" [type]="icons.Close" [color]="color.Black"> </lsq-icon>
        </lsq-button>
    </div>
    <div class="modal-body" *ngIf="isSubmitting">
        <lsq-circle-loader></lsq-circle-loader>
    </div>
    <div class="modal-body" *ngIf="!isSubmitting">
        <span id="remove-file-text" *ngIf="modal?.data?.removeSingleFile"
            >Are you sure you want to remove <b>{{ modal?.data?.document?.fileName }}</b> from
            <b>{{ modal?.data?.documentLabel }}</b>?
        </span>
        <span id="remove-document-text" *ngIf="!modal?.data?.removeSingleFile"
            >Are you sure you want to remove the document request for
            <b>{{ modal?.data?.documentLabel }}</b>?
        </span>
    </div>
    <div class="modal-footer" *ngIf="!isSubmitting">
        <div class="modal-footer-left">
            <lsq-button
                appearance="secondary"
                (buttonClick)="modalService.closeModal()"
                class="cancel-btn pull-left"
            >
                Cancel
            </lsq-button>
        </div>
        <div class="modal-footer-right">
            <lsq-button
                class="confirm-btn"
                appearance="primary"
                [size]="'lg'"
                (buttonClick)="confirmModal()"
            >
                {{modal?.data?.removeSingleFile === true ? 'Remove File' : 'Remove Document'}}
            </lsq-button>
        </div>
    </div>
</div>
